import { useSearchParams } from 'next/navigation';
import { parseBoolean } from '@lib/util/parser';

function useSearchHandle(): {
    location: string | null
    term: string | null
    category: string | null
    page: number
    search: string | null
    sort_by: string | null
    gift_card_id: string | null,
    provisioned_card_id: string | null,
    enableSearch: boolean | null,
    ref: string | null,
    awc: string | null,
    providerId: string | null
} {
    const searchParams = useSearchParams();
    const locationParam = searchParams.get('location');
    const termParam = searchParams.get('term');
    const categoryParam = searchParams.get('category');
    const searchParam = searchParams.get('search');
    const pageParam = searchParams.get('page');
    const sort_byParam = searchParams.get('sort_by');
    const gift_card_id = searchParams.get('gift_card_id');
    const provisioned_card_id = searchParams.get('provisioned_card_id');
    const enable_search = parseBoolean(searchParams.get('enableSearch') || 'false');
    const ref = searchParams.get('ref');
    const awc = searchParams.get('awc');
    const providerId = searchParams.get('providerId');
    return {
        location: locationParam,
        term: termParam,
        category: categoryParam,
        search: searchParam,
        page: Number(pageParam || 1),
        sort_by: sort_byParam,
        gift_card_id: gift_card_id,
        provisioned_card_id: provisioned_card_id,
        enableSearch: enable_search || false,
        ref: ref,
        awc: awc,
        providerId
    };
}

export default useSearchHandle;
